
<template>
  <div class="selectGoodList">
    <el-table
      ref="multipleTable"
      :data="goodItems"
      border
      size="mini"
      style="width: 100%;margin-top:20px;"
      height="calc(100vh - 180px)"
      :summary-method="getSummaries"
      show-summary
    >
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column
        v-for="(item,index) in tableColumnDatas"
        :key="index"
        :prop="item.class"
        :label="item.labelName"
        :sortable="item.sortEnable"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="item.isNumFilter">{{scope.row[scope.column.property]|numFilter}}</span>
          <span v-else>{{scope.row[scope.column.property]}}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { numFilter } from "@/utils/filters";
export default {
  name: "selectGoodList",
  props: {
    goodItems: {
      type: Array
    }
  },
  data() {
    return {
      tableColumnDatas: [
        { class: "productNumber", labelName: "存货编码", sortEnable: false },
        { class: "productName", labelName: "存货名称", sortEnable: false },
        //  { class: "材料", labelName: "类型", sortEnable: false },
        { class: "model", labelName: "规格型号", sortEnable: false },
        { class: "factoryName", labelName: "厂商", sortEnable: false },
        { class: "unit", labelName: "计量单位", sortEnable: false },
        { class: "quantity", labelName: "数量", sortEnable: false },
        {
          class: "unitPrice",
          labelName: "单价",
          sortEnable: false,
          isNumFilter: true
        },
         {
          class: "taxRate",
          labelName: "税率",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "bidPrice",
          labelName: "中标裸税单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "totalPurePrice",
          labelName: "裸税合价",
          sortEnable: false,
          isNumFilter: false,
        },
        {
          class: "totalPrice",
          labelName: "金额",
          sortEnable: false,
          isNumFilter: true
        },
        { class: "remarks", labelName: "备注", sortEnable: false }
      ]
    };
  },
  methods: {
    //设置小计
    getSummaries(param) {
      let _this = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 5) {
          sums[index] = "合计";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (
          !values.every(value => isNaN(value)) &&
          (column.property == "quantity" || column.property == "totalPrice"|| column.property == "totalPurePrice")
        ) {
          sums[index] = values.reduce((prev, curr) => {
            // curr.replace(/,/g, "")
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          // sums[index] += '';
          // this.$set();
          
            sums[index] = numFilter(sums[index]);
          
        } else {
          sums[index] = "";
        }
      });
      return sums;
    }
  },
};
</script>
<style scoped >
/deep/.el-tabs__item {
  height: 56px;
  line-height: 56px;
  width: 160px;
  padding: 0 !important;
  font-size: 18px;
  color: #666666 !important;
}
/deep/.el-tabs__header {
  padding-right: 0;
}
>>> .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background: #fff;
  color: #069dbc !important;
  border-bottom-color: #e4e7ed;
  padding: 0;
}
>>> .el-tabs__item:hover {
  color: #069dbc;
}
</style>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
 .selectGoodList{
  overflow: auto;
  //  /deep/.el-table__body-wrapper{
  //    height: auto!important;
  //  }
 }
.el-container {
  padding-top: 0;
  .el-header {
    padding: 0;
    form {
      padding-right: 20px;
    }
  }
}

/deep/.el-tabs__header {
  padding-right: 0 !important;
  background: #d5e7ed !important;
}
.el-select {
  width: 100%;
}
.hide {
  display: none;
}

/deep/.overTimeMark {
  background-color: #e9f4fa;
  .el-tooltip {
    color: #333333;
  }
}

/deep/.el-form-item__content {
  width: 60%;
}
/deep/.el-form-item {
  width: 100%;
}
/deep/.el-date-editor {
  width: 100% !important;
}
</style>
